import script from "./ElementDataSource.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementDataSource.vue?vue&type=script&setup=true&lang=js"

import "./ElementDataSource.vue?vue&type=style&index=0&id=5c11d920&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c11d920"]])

export default __exports__